import { Component, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration';

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.css']
})
export class InvoiceListComponent implements OnInit {

  invoiceData: any = []

  constructor(public shared: SharedService, public apiService: ApiServiceService) {
    this.shared.isWhiteMenu = true;
  }

  ngOnInit(): void {
    this.initData()
  }

  async initData() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_INVOICE_DATA, {});
    console.log("res", res)
    if (res && !res.error && res.data) {
      this.invoiceData = [];
      for(let d of res.data) {
        try {
          d.plan_data = JSON.parse(d.plan_data);
        } catch(e) {
          d.plan_data = {};
        }
        this.invoiceData.push(d);
      }
      // this.invoiceData = []
    }
  }

  async printInvoice(id: any) {
    this.shared.isLoader = true;
    this.apiService.isBlob = true;
    await this.apiService.POST_apiRequest(configuration.ENDPOINT.COMMON_PDF, { type: "invoice", id: id })
    this.shared.isLoader = false;
  }

} 
